<script lang="ts">
    import time from "../../stores/time";
</script>

<span id="minutes" class="clock-component font-semibold">{ $time.format('mm') }</span>